var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"question-error-wrap"},[_vm._t("default"),_c('div',{staticClass:"question-error-wrap__error q-mt8",attrs:{"role":"alert"}},[_vm._v(_vm._s(_vm.$t(_vm.error)))])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }